import React from "react";
import SignInFormBrand from "../components/SignInFormBrand";

export default function SignIn() {
  return <SignInFormBrand />;
}
